<template>
    <div class="room">
        <div class="container">
            <b-row>
                <b-col md="4">
                    <b-card-group deck>
                        <b-card header="User Actions" header-tag="header">
                            <div v-if="!getMyName" class="text-left">
                                <form ref="form" @submit.stop.prevent="handleSubmit">
                                    <b-form-group :state="nameState" label="Name" label-for="name-input"
                                        invalid-feedback="Name is required">
                                        <b-form-input autofocus id="name-input" v-model="name" :state="nameState"
                                            required>
                                        </b-form-input>
                                    </b-form-group>
                                </form>
                                <button type="submit" class="btn btn-success btn-block" @click="handleSubmit">Join</button>
                            </div>
                            <div v-if="getMyName">
                                <b-row v-for="row in 3" :key="row">
                                    <b-col cols="4" v-for="col in 3" :key="col">
                                        <b-button block pill size="lg" variant="outline-secondary" @click="submitVote((row * 3) + (col - 3))">{{ getFib((row * 3) + (col - 3)) }}</b-button>
                                    </b-col>
                                </b-row>
                                <button type="button" @click="submitVote(0)" class="btn btn-warning btn-block">Reset My Vote</button>
                            </div>
                        </b-card>
                    </b-card-group>
                </b-col>
                <b-col md="4">
                    <b-list-group v-if="getMyName">
                        <b-list-group-item class="d-flex justify-content-between align-items-center">
                            <font-awesome-icon icon="times" :style="{ color: '#B71C1C' }" id="delete-user"
                                @click="deleteUser()"></font-awesome-icon>
                            <div class="user-name">{{ getMyName }}</div>
                            <b-badge variant="primary" pill>{{ $store.getters.getSubmittedVote }}</b-badge>
                        </b-list-group-item>
                        <b-list-group-item v-for="(value, id) in getOtherUsers" :key="id" class="d-flex justify-content-between align-items-center">
                            <font-awesome-icon icon="times" :style="{ color: '#B71C1C' }" id="delete-user" @click="deleteUser(id)"></font-awesome-icon>
                            <div class="user-name">{{ value.name }}</div>
                            <b-badge variant="primary" pill v-if="allVoted">{{ value.submittedVote }}</b-badge>
                            <font-awesome-icon v-else :style="{ color: value.submittedVote ? '#28a745' : '#E0E0E0' }" icon="check-circle"></font-awesome-icon>
                        </b-list-group-item>
                    </b-list-group>
                    <b-list-group v-else>
                        <b-list-group-item v-for="(value, id) in getAllUsers" :key="id"
                            class="d-flex justify-content-between align-items-center">
                            <div class="user-name">{{ value.name }}</div>
                            <b-badge variant="primary" pill v-if="allVoted">{{ value.submittedVote }}</b-badge>
                            <font-awesome-icon v-else :style="{ color: value.submittedVote ? '#28a745' : '#E0E0E0' }" icon="check-circle"></font-awesome-icon>
                        </b-list-group-item>
                    </b-list-group>
                    <h6 v-if="!getAllUsers">ROOM IS EMPTY</h6>
                    <br>
                </b-col>
                <b-col md="4">
                    <b-card-group deck>
                        <b-card header="Admin Actions" header-tag="header">
                            <button type="button" class="btn btn-danger btn-block" @click="resetVotes">Reset Votes</button>
                            <button type="button" class="btn btn-primary btn-block" @click="setForceReveal">Reveal Score</button>
                        </b-card>
                    </b-card-group>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                name: '',
                nameState: null
            }
        },
        mounted: function () {
            this.showFrom();
        },
        beforeCreate: function () {
            this.$store.dispatch('verifyUser');       
            this.$store.dispatch('setUsers');
        },
        methods: {
            getFib(num) {
                return this.$store.getters.getFib(num);
            },
            submitVote(vote) {
                this.$store.commit('submitVote', vote);
            },
            deleteUser(userUuid) {
                this.$store.commit('deleteUser', userUuid);
            },
            resetVotes() {
                this.$store.commit('resetVotes');
            },
            showFrom() {
                if (localStorage.uuid) {
                    this.$store.commit('retrieveUser');
                }
            },
            checkFormValidity() {
                const valid = this.$refs.form.checkValidity() && this.name.trim() !== "";
                this.nameState = valid ? 'valid' : 'invalid';
                return valid;
            },
            handleOk(bvModalEvt) {
                bvModalEvt.preventDefault();
                this.handleSubmit();
            },
            handleSubmit() {
                if (!this.checkFormValidity()) {
                    return;
                }
                this.$store.commit('submitName', this.name);
            },
            setForceReveal() {
                this.$store.commit('setForceReveal');
            }
        },
        computed: {
            getOtherUsers() {
                return this.$store.getters.getOtherUsers;
            },
            getAllUsers() {
                return this.$store.getters.getAllUsers;
            },
            getMyName() {
                return this.$store.getters.getMyName;
            },
            getSubmittedVote() {
                return this.$store.getters.getSubmittedVote;
            },
            allVoted() {
                return this.$store.getters.allVoted;
            }
        }
    }
</script>

<style scoped>
    .btn-block {
        margin-top: 15px;
        margin-bottom: 15px;
    }

    .action-btn {
        cursor: pointer;
    }

    #current-user {
        cursor: pointer;
    }

    #delete-user {
        cursor: pointer;
    }

    .user-name {
        text-transform: capitalize;
    }

    #action {
        border-bottom: 1px solid #E0E0E0;
        background-color: white;
        overflow: hidden;
        position: fixed;
        top: 0;
        width: 100%;
        z-index: 1;
    }
</style>